import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export type ExcelColumn = {
  header: string;
  key: string;
};

export async function exportRowsToExcel(
  rows: object[],
  columns: ExcelColumn[],
  options: { sheetName?: string; fileNamePrefix: string },
) {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "MoneyEU CRM";
  const sheet = workbook.addWorksheet(options.sheetName ?? "Export");

  sheet.columns = columns.map((col) => ({
    header: col.header,
    key: col.key,
  }));

  // Write by column order. addRow(object) skips keys that clash with ExcelJS Row
  // properties (notably `status`), which left Status columns empty.
  rows.forEach((row) => {
    const record = row as Record<string, unknown>;
    sheet.addRow(columns.map((col) => record[col.key]));
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `${options.fileNamePrefix}-${Date.now()}.xlsx`);
}
